<template>
  <div id="app">
<!--    <img src="./assets/logo.png">-->
<!--    <router-link :to="{path: '/index'}">去首页</router-link>-->
    <header-div ref="headerDivRef" @locationHash="_locationHash"></header-div>
    <router-view ref="routerViewRef"/>
    <footer-div v-if="!isBackstage"></footer-div>
  </div>
</template>

<script>
import HeaderDiv from '@/views/homePage/headerAll.vue'
import footerDiv from '@/views/homePage/footerAll.vue'

export default {
  name: 'App',
  components: {
    HeaderDiv,
    footerDiv
  },
  provide () {
    return {
      reload: this.PageRefresh,
      openLogin: this.openLogin
    }
  },
  data () {
    return {
      isBackstage: true
    }
  },
  watch: {
    $route (to, form) {
      this.isMaster()
    }
  },
  created () {
  },
  mounted () {
    // this.isMaster()
  },
  methods: {
    isMaster () {
      if (this.$route.path.includes('/backstage')) {
        this.isBackstage = true
      } else {
        this.isBackstage = false
      }
    },
    PageRefresh () {
      console.log('刷新页面')
      this.$refs.headerDivRef.PageRefresh()
    },
    openLogin () {
      console.log('打开登录矿')
      this.$refs.headerDivRef.logIn()
    },
    _locationHash (path) {
      const height = document.querySelector(path).offsetTop - 55
      window.scrollTo({
        top: height,
        behavior: 'smooth'
      })
    }
  }
}
</script>

<style lang="scss">
$themeColor: #f33348;
html,body,#app {
  background: #fff;
  min-height: 100vh;
  min-width: 100vw;
}
body {
  margin: 0;
}
#app {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  margin: 0;
  background: #fff;
}
</style>



// WEBPACK FOOTER //
// src/App.vue